export default "assets/images/icons/search-3541f3c3.svg";